import { Flex, Spinner } from "@radix-ui/themes";
import PropTypes from "prop-types";

Loading.propTypes = {
  children: PropTypes.node,
};

export default function Loading({ children }) {
  return (
    <Flex gap="3" align="center" justify="center">
      {children}
      <Spinner size="2" />
    </Flex>
  );
}
